import checkIcon from '../../../assets/media/icons/check-icon.svg';
import Text from '../../../ui/Text/Text';
import './inResult.scss';

interface InResultProps {
  id?: string;
}

const InResult = ({ id }: InResultProps) => (
  <section className='in-result' id={id}>
    <Text variant='h3' fontWeight={600} className='title'>
      В РЕЗУЛЬТАТЕ ТЫ:
    </Text>
    <div className='container'>
      <div className='in-result-grid'>
        <div className='in-result-item'>
          <div className='check-icon'>
            <img src={checkIcon} alt='check icon' />
          </div>
          <Text variant='subtitle3' fontWeight={400} className='label'>
            Сформируешь свои бизнес-цели
          </Text>
        </div>
        <div className='in-result-item'>
          <div className='check-icon'>
            <img src={checkIcon} alt='check icon' />
          </div>
          <Text variant='subtitle3' fontWeight={400} className='label'>
            Определишь направления запуска бизнеса
          </Text>
        </div>
        <div className='in-result-item'>
          <div className='check-icon'>
            <img src={checkIcon} alt='check icon' />
          </div>
          <Text variant='subtitle3' fontWeight={400} className='label'>
            Составишь поэтапный план действий
          </Text>
        </div>
      </div>
    </div>
  </section>
);

export default InResult;
